import React, { Component } from 'react'
import request from '../../../lib/requester'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import moment from 'moment'
import _, { now } from 'lodash'
import { Loader } from "react-overlay-loader";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

class ProcessDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      payment_process_no: '',
      dataTable: [],
      error: [],
      success: '',
      glDate: new Date(),
      transferDate: new Date()
    }
  }

  componentDidMount = () => {
    let { id } = this.props.match.params;
    this.setState({ payment_process_no: id })
    this.getData()
  }

  getData = () => {
    let { id } = this.props.match.params;
    let url = '/api/traces_chd/v1/payment/detail-process'
    let param = {
      payment_process_no: id
    }
    request.postCHD(url, param, {
      success: function(response) {
        let data = response.data.data
        this.setState({ dataTable: data })
      }.bind(this),
      error: function(e) {

      }.bind(this)
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: 'AP Invoice No',
          accessor: 'ap_invoice_no',
          width: 300
        },
        // {
        //   Header: 'Bank',
        //   accessor: 'bank',
        // },
        {
          Header: 'PPh Type',
          accessor: 'pph_type',
        },
        // {
        //   Header: 'Cost Center',
        //   accessor: 'cost_center',
        // },
        {
          Header: 'Amount',
          accessor: 'amount',
          className: 'text-right',
          Cell: function (row) {
            return (
              <span>{row.value ? row.value.toLocaleString('de-DE', { minimumFractionDigits: 2 }) : ''}</span>
            )
          }
        },
        // {
        //   Header: 'Sub Account',
        //   accessor: 'sub_account',
        // },
        {
          Header: 'Transfer File',
          accessor: 'payment_process_no',
          Cell: row => (
            <span><button className="btn btn-info btn-sm btn-block" onClick={() => { this.generateTxt(row) }}><i className="fa fa-file" /> Generate TXT</button></span>
          )
        },
        {
          Header: 'Download XLS',
          accessor: 'ap_invoice_no',
          Cell: row => (
            <span><button className="btn btn-success btn-sm btn-block" onClick={() => { this.generateReport(row, 'xls') }}><i className="fa fa-file-excel" /> Download</button></span>
          )
        },
        {
          Header: 'Download PDF',
          accessor: 'ap_invoice_no',
          Cell: row => (
            <span><button className="btn btn-danger btn-sm btn-block" onClick={() => { this.generateReport(row, 'pdf') }}><i className="fa fa-file-pdf" /> Download</button></span>
          )
        },
        {
          Header: 'Process Invoice',
          accessor: 'ap_invoice_no',
          Cell: row => (
            <span><button className="btn btn-warning btn-sm btn-block" onClick={() => { this.processInvoice(row) }} disabled={row.original.invoice_status === 'S' ? true : false}><i className="fa fa-check-circle" /> Process</button></span>
          )
        }
      ],
      rows: this.state.dataTable
    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
    />)
  }

  generateTxt = (row) => {
    let ap_invoice_no = new Buffer(row.row.ap_invoice_no).toString('base64')    
    let url = '/api/traces_chd/v1/util/forwarding-url'
    let glDate = this.state.glDate ? moment(this.state.glDate).format('YYYYMMDD') : ''
    let transferDate = this.state.transferDate ? moment(this.state.transferDate).format('YYYYMMDD') : ''
    let param = {
      url: "/api/traces_chd/v1/payment/generate-txt?ap_invoice_no=" + ap_invoice_no + '&glDate=' + glDate + '&trfDate=' + transferDate
    }
    request.postCHD(url, param, {
      success: function(response) {
        let { data } = response.data
        let url = data.url
        window.open(url, '_blank')
      },
      error: function(e) {
        this.setState({ error: [e.message]})
      }.bind(this)
    })
  }

  generateReport = (row, type) => {
    let url = '/api/traces_chd/v1/payment/get-data-report'
    let param = {
      ap_invoice_no: row.row.ap_invoice_no,
      type: type,
      glDate: this.state.glDate,
      transferDate: this.state.transferDate
    }
    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let {data} = response.data
        this.setState({ loading: false })
        let url = data.fullpath
        window.open(url, '_blank')
      }.bind(this),
      error: function(e) {
        this.setState({ 
          error: [e.response.data.message || 'Failed generate report'], 
          loading: false 
        })
      }.bind(this)
    })
  }

  processInvoice = (row) => {
    if (window.confirm('Are you sure want to process invoice: ' + row.value + '?')) {
      let url = '/api/traces_chd/v1/payment/process-payment'
      let param = {
        ap_invoice_no: row.value,
        glDate: this.state.glDate,
        transferDate: this.state.transferDate,
        payment_process_no: this.state.payment_process_no
      }

      this.setState({ loading: true })
      request.postCHD(url, param, {
        success: function(response) {
          this.setState({ loading: false, success: response.data.message || "Invoice has been submitted successfully"})
          window.setTimeout(() => {
            window.location.reload();
          }, 3000)
        }.bind(this),
        error: function(e) {
          this.setState({ loading: false, error: [e.response.data.message || "Failed to process invoice"]})
        }.bind(this)
      })
    }
  }

  handleGlDate = (date) => {
    this.setState({ glDate: date })
  }

  handleTransferDate = (date) => {
    this.setState({ transferDate: date })
  }

  render() {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row ml-1">
            <div className="col-lg-12">
              <div className="card card-info">
                <div className="card-header">Payment Process List</div>
                <div className="card-body">
                  {this.showNotification()}
                  <div className="form-group row">
                    <div className="col-md-6">Payment Process No:<br /> <h2>{this.state.payment_process_no}</h2></div>
                    <div className="col-md-3">
                      <label>GL Date</label><br />
                      <DatePicker
                        selected={this.state.glDate}
                        dateFormat="d-MMM-yyyy"
                        className="form-control"
                        popperPlacement="top-end"
                        onChange={this.handleGlDate}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Transfer Date</label>
                      <DatePicker
                        selected={this.state.transferDate}
                        dateFormat="d-MMM-yyyy"
                        className="form-control"
                        popperPlacement="top-end"
                        onChange={this.handleTransferDate}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {this.renderTable()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loader fullPage loading={this.state.loading} />
      </section>
    )
  }
}

export default ProcessDetail